// extracted by mini-css-extract-plugin
export var borderRadius = "_5v-4";
export var large = "_5v-3";
export var logoContainer = "_5v-0";
export var nameLogo = "_5v-2";
export var small = "_5v-1";